import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { chip } = semanticThemeTokens;

export const chipWrapper = style({
  cursor: "default",
  display: "flex",
  overflow: "hidden",
  alignItems: "center",

  paddingTop: primitiveTokens.sizing["1x"],
  paddingRight: primitiveTokens.sizing["2x"],
  paddingBottom: primitiveTokens.sizing["1x"],
  paddingLeft: primitiveTokens.sizing["2x"],
  borderRadius: primitiveTokens.radii.xs,
  borderWidth: primitiveTokens.strokes.md,
  borderStyle: "solid",
  borderColor: chip.borderColor,

  backgroundColor: chip.backgroundColor,
  color: chip.textColor,
  gap: primitiveTokens.sizing["2x"],
  selectors: {
    "&[data-disabled]": {
      backgroundColor: chip.disabledBackgroundColor,
      color: chip.disabledTextColor,
      borderColor: chip.disabledBorderColor
    }
  }
});

export const interactiveChip = style({
  selectors: {
    "&:not([data-disabled]):hover": {
      borderColor: chip.hoverBorderColor
    }
  }
});

export const clickableChip = style({ cursor: "pointer" });

/** The close button brings its own space on the right. */
export const closableChip = style({
  paddingRight: primitiveTokens.sizing["1x"]
});

export const chipContent = style({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: primitiveTokens.type.sm
});

export const chipCloseButton = style({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  width: primitiveTokens.sizing["4x"],
  height: primitiveTokens.sizing["4x"],
  stroke: chip.closeIconColor,
  background: "none",
  border: "none",
  color: chip.closeIconColor,
  padding: 0,
  selectors: {
    "&:disabled, &[aria-disabled='true']": {
      cursor: "default",
      color: chip.disabledCloseIconColor
    }
  }
});
